import { Box, Paper } from "@mui/material";
import LogHeader from "./LogHeader";
import LogTable from "./LogTable";

const LogViewer = () => {
  return (
    <Paper elevation={0}>
      <LogHeader />
      <Box component="main" sx={{ width: "100%" }}>
        <LogTable />
      </Box>
    </Paper>
  );
};

export default LogViewer;
